import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GlobalState } from "./index.types";

const initialState: GlobalState = {
  isfirstLogin: true,
  navigationPathisRecording: false,
  currentNavigationPath: null,
  openDosepotConnection: false,
  savedStatus: null,
};

const name = "globalStates";

export const globalSlice = createSlice({
  name,
  initialState,
  reducers: {
    setFirstLogin: (state) => {
      state.isfirstLogin = false;
    },
    setRecording: (state, { payload }: PayloadAction<boolean>) => {
      state.isRecording = payload;
    },
    setOpenDosepotConnection: (state, { payload }: PayloadAction<boolean>) => {
      state.openDosepotConnection = payload;
    },
    setCurrentNavigationPath: (state, { payload }: PayloadAction<string | null>) => {
      state.currentNavigationPath = payload;
    },
    setPiFCloseFunction: (state, { payload }: PayloadAction<{ savedStatus: any }>) => {
      const { savedStatus } = payload;
      state.savedStatus = savedStatus;
    },
    clearPifCloseStates: (state) => {
      state.savedStatus = null;
    },
  },
});

export const { clearPifCloseStates, setPiFCloseFunction, setFirstLogin, setCurrentNavigationPath, setOpenDosepotConnection, setRecording } =
  globalSlice.actions;

export default globalSlice.reducer;
